export const COLOR_BLACK = "#000";
export const COLOR_LESS_BLACK = "#15161a";
export const COLOR_WHITE = "#ffffff";
export const COLOR_LIGHT_GRAY = "#707070";
export const COLOR_VERY_LIGHT_GRAY = "#F0F0F0";
export const COLOR_SLIGHTLY_DARKER_WHITE = "#FDFDFD";
export const COLOR_GOLD = "#FFD700";
export const COLOR_GREEN = "#56e817";
export const COLOR_ORANGE = "#ff8834";
export const COLOR_RED = "#c11b1b";
export const COLOR_MAIN = "#0045aa";
export const COLOR_SECONDARY = "#145976";
export const GRADIENT_MAIN =
  "radial-gradient(circle, hsla(0, 0%, 0%, 1) 0%, hsla(60, 3%, 19%, 1) 100%)";
